import { Button } from "../ui-comp/button";
import {
  // CircleUserRound,
  LogOut,
  SquareChevronLeft,
} from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/vm_logo.png";
import { MENU, VIEWER } from "../../constants";
import { cn } from "../../lib/utils";
import { useState } from "react";
import { useGetUserRole } from "../../hooks/useGetUserRole";

const SideBar = ({ isSidebarOpen, setSidebar }) => {
  const [collapsed, setCollapsed] = useState(false);

  const { viewer } = useGetUserRole();

  // console.log(data)
  const location = useLocation();

  // const [openLogout, setOpenLogout] = useState(false);
  // const handleLogout = () => {
  //   setOpenLogout(true);
  // };

  const logout = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  //Filter the menu based on ownership status
  const filteredMenu = viewer ? VIEWER : MENU;

  return (
    <section
      className={`h-full bg-neutral200 relative flex flex-col transition-all duration-300 p-3 ${
        collapsed ? "w-24" : "w-64"
      }`}
    >
      <div
        className={`flex p-3 bg-white border border-secondary100 rounded-xl mb-3 transition-all duration-300
    ${
      collapsed
        ? "flex-col items-center w-16 gap-2"
        : "flex-row justify-between items-center gap-4"
    }
  `}
      >
        {/* Left side: Logo + Text */}
        <div
          className={`flex transition-all duration-300 ${
            collapsed ? "flex-col items-center" : "flex-row items-center gap-2"
          }`}
        >
          <img src={logo} alt="logo" className="w-[25px]" />

          {/* Text that collapses smoothly */}
          <div
            className={`overflow-hidden transition-all duration-300 ease-in-out ${
              collapsed
                ? "max-w-0 opacity-0 h-0"
                : "max-w-[150px] opacity-100 h-auto"
            }`}
          >
            <p className="text-sm text-darkGrey whitespace-nowrap">
              Turingtower VM
            </p>
            <p className="text-xs text-neutral600 whitespace-nowrap">
              Business
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white border border-secondary100 rounded-xl text-sm relative h-full flex flex-col justify-between">
        <div>
          <div className="p-2">
            {!collapsed ? (
              <p className="text-xs p-1 text-neutral600 font-medium mb-1">
                MAIN
              </p>
            ) : (
              <p className="mt-3 mb-2  w-full border-b"></p>
            )}
          </div>

          {filteredMenu.map((menu, index) => {
            const isActive = location.pathname === `${menu.route}`;
            const Icon = menu.icon;
            return (
              <div className="relative" key={index}>
                <div className="px-3">
                  <NavLink
                    key={menu.route}
                    to={`${menu.route}`}
                    className={cn(
                      " font-medium flex items-center gap-3 py-2 px-2 hover:text-neutral1000 hover:rounded cursor-pointer transition-colors",
                      isActive
                        ? "text-neutral1000 bg-neutral200 rounded-lg"
                        : "text-neutral800",
                      collapsed ? "px-1" : "px-2 "
                    )}
                    onClick={() => setSidebar && setSidebar(!isSidebarOpen)}
                  >
                    <div className="min-w-[20px]">
                      <Icon
                        size={20}
                        color={isActive ? "#29C2E4" : "#606060"}
                      />
                    </div>

                    {/* Label fades and collapses smoothly */}
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        collapsed
                          ? "max-w-0 opacity-0"
                          : "max-w-full opacity-100"
                      }`}
                    >
                      <span className="block whitespace-nowrap">
                       {menu.title}
                      </span>
                    </div>
                  </NavLink>
                </div>
                {isActive && !collapsed && (
                  <div className="w-[5px] h-[20px] bg-aero rounded-l-md absolute right-0 top-2"></div>
                )}
              </div>
            );
          })}
        </div>

        {/* Toggle Button */}
        <div
          className={`flex py-4 px-3 ${
            collapsed ? "justify-center" : "justify-start"
          }`}
        >
          <button
            onClick={() => setCollapsed((prev) => !prev)}
            className="focus:outline-none transition-all duration-300"
          >
            <SquareChevronLeft
              size={16}
              className={`transition-transform duration-300 ${
                collapsed ? "rotate-180" : "rotate-0"
              }`}
            />
          </button>
        </div>
      </div>

      {/* {data?.status && ( */}
      {/* // <div className={cn(!data?.status ? "absolute right-3 left-10 bottom-20": 'pt-4')}> */}
      <div className={cn("pt-4")}>
        {/* <NavLink
          to={"/dashboard/settings"}
          className={cn(
            "flex items-center gap-3 py-3 px-4 text-grey font-medium",
            location.pathname === "/dashboard/settings"
              ? "text-blue-600"
              : "text-gray-600"
          )}
          onClick={() => setSidebar && setSidebar(!isSidebarOpen)}
        >
          <div className="block">
            <Setting2
              size="20"
              color={
                location.pathname === "/dashboard/settings"
                  ? "#2563eb"
                  : "#4b5563"
              }
              variant={
                location.pathname === "/dashboard/settings" ? "Bold" : "Linear"
              }
            />
          </div>
          <p className="origin-left">Settings</p>
        </NavLink> */}

        {/* <Signout
            handleLogout={handleLogout}
            open={openLogout}
            onOpenChange={setOpenLogout}
          > */}
        <div className="py-2 bg-white border border-secondary100 rounded-xl">
          <Button
            variant="ghost"
            className={`flex gap-3 text-[16px] justify-start items-center font-medium text-red-600 hover:text-red-400 ${
              collapsed ? "px-4" : "px-3 "
            }`}
            onClick={logout}
          >
            <div className="block">
              <LogOut size="20" />
            </div>

            <div
              className={`overflow-hidden transition-all duration-300 ${
                collapsed ? "max-w-0 opacity-0" : "max-w-full opacity-100"
              }`}
            >
              <span className="block whitespace-nowrap font-medium">
                Sign out
              </span>
            </div>
          </Button>
        </div>
        {/* </Signout> */}

        {/* <div className="flex gap-3 pt-4 pl-[8px] items-center">
            <div className="block">
              <CircleUserRound color="#fff" size={36} />
            </div>
            <div className="origin-left text-sm">
              <p className="text-[#98A2B3] text-sm truncate w-[120px]">
                {data?.email}
              </p>
            </div>
          </div> */}
      </div>
      {/* )} */}
    </section>
  );
};

export default SideBar;

// import { useState } from "react";
// import { Home, Settings, Menu } from "lucide-react";
// import { Button } from "../../../src/components/ui/button"; // ShadCN Button

// const menuItems = [
//   { icon: <Home size={20} />, label: "Home" },
//   { icon: <Settings size={20} />, label: "Settings" },
// ];

// export default function Sidebar() {
//   const [collapsed, setCollapsed] = useState(false);

//   return (
//     <aside
//       className={`h-screen bg-gray-900 text-white flex flex-col transition-all duration-300 ${
//         collapsed ? "w-16" : "w-64"
//       }`}
//     >
//       {/* Toggle Button */}
//       <div className="p-4">
//         <Button
//           variant="ghost"
//           size="icon"
//           onClick={() => setCollapsed((prev) => !prev)}
//         >
//           <Menu className="text-white" />
//         </Button>
//       </div>

//       {/* Menu Items */}
//       <nav className="flex flex-col gap-2 px-2 mt-4">
//         {menuItems.map((item, index) => (
//           <div
//             key={index}
//             className="flex items-center p-3 rounded-md hover:bg-gray-800 cursor-pointer transition-colors"
//           >
//             {/* Icon stays visible always */}
//             <div className="min-w-[20px]">{item.icon}</div>

//             {/* Label fades and collapses smoothly */}
//             <div
//               className={`ml-4 overflow-hidden transition-all duration-300 ${
//                 collapsed ? "max-w-0 opacity-0" : "max-w-full opacity-100"
//               }`}
//             >
//               <span className="block whitespace-nowrap">{item.label}</span>
//             </div>
//           </div>
//         ))}
//       </nav>
//     </aside>
//   );
// }
